<footer class="bg-gradient-to-r from-primary-800 to-primary-700 text-white">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
      <!-- Company Info -->
      <div class="col-span-1 md:col-span-2">
        <h3 class="text-2xl font-bold text-white mb-4">Finance ONE</h3>
        <p class="text-primary-100/80 mb-4">
          Det hurtigste regnskabsprogram til bogholdere og revisorer.
        </p>
        <div class="text-primary-100/80 space-y-2">
          <p>Finance ONE A/S</p>
          <p>CVR: 35228306</p>
          <p>Tlf: 45 81 46 46</p>
          <p>Email: info&#64;financeone.dk</p>
        </div>
      </div>

      <!-- Quick Links -->
      <div>
        <h4 class="text-lg font-semibold mb-4">Genveje</h4>
        <ul class="space-y-2 text-primary-100/80">
          <li><a routerLink="/" class="hover:text-white transition-colors">Hjem</a></li>
          <li><a routerLink="/funktioner" class="hover:text-white transition-colors">Funktioner</a></li>
          <li><a routerLink="/priser" class="hover:text-white transition-colors">Priser</a></li>
          <li><a routerLink="/guides" class="hover:text-white transition-colors">Guides</a></li>
          <li><a routerLink="/nyheder" class="hover:text-white transition-colors">Nyheder</a></li>
          <li><a routerLink="/kontakt" class="hover:text-white transition-colors">Kontakt</a></li>
        </ul>
      </div>

      <!-- Newsletter -->
      <div>
        <h4 class="text-lg font-semibold mb-4">Nyhedsbrev</h4>
        <p class="text-primary-100/80 mb-4">Tilmeld dig vores nyhedsbrev for opdateringer og tips.</p>
        <form class="flex flex-col space-y-2">
          <input
            type="email"
            placeholder="Din email"
            class="px-4 py-2 rounded-lg bg-primary-900/30 border border-white/10 text-white placeholder-primary-100/60 focus:outline-none focus:border-white/30"
          >
          <button type="submit" class="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-500 transition-colors">
            Tilmeld
          </button>
        </form>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="border-t border-white/10 mt-8 pt-8 text-center text-primary-100/70">
      <p>&copy; {{ currentYear }} Finance ONE A/S. Alle rettigheder forbeholdes.</p>
    </div>
  </div>
</footer>
